<template>
  <div :class="$style.page">
    <Loading :loading="loading">
      <Title title="站内信" mode="margin" />

      <!-- 搜索参数 -->
      <Item title="" :class="$style.trade">
        <template v-for="(item, index) in statusList">
          <Button
            :type="index == statusSelect ? 'primary' : ''"
            round
            :key="index"
            @click="statusSelectChange(index)"
          >
            {{ item.name }}
          </Button>
        </template>
      </Item>

      <Row>
        <Item title="类型">
          <el-select v-model="mailTypeSelect" placeholder="全部">
            <el-option
              v-for="(item, index) in mailSiteTypeList"
              :key="index"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </Item>

        <Item title="关键词">
          <el-input :class="$style.keywords" v-model="keyword"></el-input>
        </Item>

        <Button :class="$style.btn" type="primary" @click="pageChange(1)">
          搜索
        </Button>
        <Button :class="$style.btn" @click="resetSearch">重置</Button>
      </Row>

      <Divider />

      <!-- 搜索结果 -->
      <div :class="$style.operationArea">
        <Title title="搜索结果" :count="total" />
        <div :class="$style.operation">
            <span @click="setAsRead()">设为已读</span>
            <span @click="allSetAaRead()">全部设为已读</span>
            <span @click="delectEvent()">删除</span>
        </div>
      </div>
      <el-table
        ref="multipleTable"
        id="fund_table"
        :data="list"
        border
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange">
      >
        <el-table-column
            type="selection"
            width="55"
            align="center"
            >
        </el-table-column>

        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.readFlag === 0 ? "未读" : "已读" }}
          </template>
        </el-table-column>

        <el-table-column
          prop="target"
          label="类型"
          width="150"
          align="center"
        />

        <el-table-column
          prop="content"
          label="标题"
          align="left"
        />

        <el-table-column
          prop="createdTime"
          label="时间"
          width="180"
          align="left"
        />
      </el-table>

      <div :class="$style.actions">
        <div :class="$style.actions_left"> 
        </div>

        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="page"
          :page-size="limit"
          :total="total"
          @current-change="pageChange"
        />
      </div>
    </Loading>
  </div>
</template>

<script>
import { mailSiteType,mailSiteList,mailSiteRead,mialSiteDel } from "@server";
import { mapActions } from "vuex";
export default {
  name: "Fund",
  data() {
    return {
      isRead:0,
      statusList: [
        {
          name: "未读短信",
          value: 0,
        },
        {
          name: "已读短信",
          value: 1,
        }
      ],
      // 表单数据
      statusSelect: 0,
      keyword: "",
      mailTypeSelect: null,

      mailSiteTypeList:[],

      loading: false,
      page: 1,
      limit: 50,
      list: [],
      total: 0,

      selectList: [],
      selectAll: false,
    };
  },
 
  methods: {
    ...mapActions("user", ["getMemberInfoAction"]),
    // 获取站内信类型
    async getMailSiteType() {
      let {code,data} = await mailSiteType();
      if(code === 200){
        this.mailSiteTypeList = data
      }
    },
    // 状态改变
    statusSelectChange(index) {
      this.statusSelect = index;
      this.isRead=this.statusList[this.statusSelect].value
      this.pageChange(1);
    },

    // 获取列表
    async getMailSiteList() {
      this.loading = true;
      let params = {
        kw: this.keyword,
        siteType: this.mailTypeSelect,
        isRead:this.statusList[this.statusSelect].value,
        limit: this.limit,
        page: this.page,
      };
      let res = await mailSiteList(params);
      if (res.code == 200) {
        this.list = res.data.list;
        this.total = res.data.total;
      }
      this.loading = false;
    },

    resetSearch() {
      this.keyword = "";
      this.mailTypeSelect = null;
      this.page = 1;
      this.getMailSiteList();
    },

    handleSelectionChange(list) {
        console.log(list)
      this.selectList = list;
    },
    pageChange(page) {
      this.page = page;
      this.getMailSiteList();
    },

    // 设为已读
    async setAsRead(){
      if(this.selectList.length <= 0){
        this.$message({ message: "请选择数据", type: "warning" });
        return;
      }
      let msgIds = this.selectList.map(item=>item.id)
      let params = {
        msgIds:msgIds,
        isReadAll:0
      }
      const res = await mailSiteRead(params);
      if(res.code === 200){
        this.$message({ message: "设置成功", type: "success" });
        this.page = 1;
        this.getMailSiteList();
        this.getMemberInfoAction;
      }else{
        this.$message({ message: res.message, type: "error" });
      }
    },
    // 全部设为已读
    allSetAaRead(){
        this.$confirm("确定全部设为已读吗？", "全部设为已读", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loadingText = "设置中...";
          this.loading = true;

          this.$refs.pushDomianTable.selectAll(true);
          let msgIds = this.selectList.map(item=>item.id)
          let params = {
            msgIds:msgIds,
            isReadAll:1
          }
          const res = await mailSiteRead(params);
          if(res.code === 200){
            this.$message({ message: "设置成功", type: "success" });
            this.page = 1;
            this.getMailSiteList();
            this.getMemberInfoAction;
          }else{
            this.$message({ message: res.message, type: "error" });
          }
          this.loading = false;
        })
        .catch(() => {});
    },
    // 删除
    delectEvent(){
      if(this.selectList.length <= 0){
        this.$message({ message: "请选择数据", type: "warning" });
        return;
      }
      
      this.$confirm("确定要删除吗？", "删除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loadingText = "删除中...";
          this.loading = true;

         let msgIds = this.selectList.map(item=>item.id)
          const res = await mialSiteDel({msgIds});
          if (res.code === 200) {
            this.$message({ message: "删除成功!", type: "success" });
            this.page = 1;
            this.getMailSiteList();
            this.getMemberInfoAction;
          }else{
            this.$message({ message: res.message, type: "error" });
          }
          this.loading = false;
        })
        .catch(() => {});
    },
  },
  created() {
    this.getMailSiteType();
    this.getMailSiteList();
  },
};
</script>

<style lang="scss" module scoped>
.page {
  min-height: 300px;
  padding: rem(50);
  font-size: rem(16);
  color: #333;
  background: $white;
  box-shadow: $box-shadow;

  .trade {
    margin-bottom: rem(40);
  }

  .divider {
    width: 6px;
    height: 1px;
    background: #333;
    margin: 0 7px;
  }

  .btn {
    min-width: rem(80);
  }

  .operationArea{
    display: flex;
    align-items: center;
    .operation{
        span{
            margin:0 10px;
            cursor: pointer;
            font-size: rem(14);
            color: #ff5c35;
            &:hover{
                color: #f97959;
            }
        }
    }
  }

  :global {
    .gl-row {
      padding-bottom: rem(40);
    }

    .gl-item {
      margin-right: rem(20);
    }

    ::v-deep .el-input {
      width: rem(160);
      margin-right: 0;

      .el-input__inner {
        padding: 0 10px;
      }

      &.el-date-editor {
        width: rem(180);
      }
    }

    ::v-deep .el-checkbox {
      margin: 0;
      transform: translateY(2px);
      .el-checkbox__label {
        color: #333;
      }
    }

  

    .el-pagination {
      flex: 1;
      @include flex();
    }
  }

  .keywords {
    width: rem(200);
  }

  .actions {
    display: flex;
    margin-top: rem(50);

    .actions_left {
      @include flex();

      .select_all {
        margin: 0 20px;
      }
    }

    .actions_right {
      flex: 1;
    }
  }
}
</style>
